export default "__VITE_ASSET__CYscomjg__"